<template>
  <Dialog v-model="showProxy" @confirm="onConfirm" @cancel="handleClose" :before-close="handleClose"
    class="view-topo-modal dialog-container" :width="'50%'" draggable>
    <template #header>
      <div class="header-container">
        <span class="title-text">{{ props.operateType == 'add' ? $str.getKey('数据分析/添加基准线') : $str.getKey('数据分析/编辑基准线')
          }}</span>
      </div>
    </template>

    <div class="modal-container">
      <!-- 已经存在的基准线：展示&编辑 -->
      <div v-for="(line, idx) in formData.existedList" :key="line.id">
        <div class="item-container">
          <div class="name-container">
            <div class="label-container">*{{ $str.getKey('数据分析/基准线名称') }}:</div>
            <el-input class="name-input" v-model="line.name" :placeholder="$str.getKey('数据分析/请输入基准线名称')"
              :disabled="line.id !== formData.editDlId"></el-input>
          </div>
          <div class="value-container">
            <div class="label-container">*{{ $str.getKey('数据分析/基准值') }}:</div>
            <el-input class="value-input" v-model="line.value" :placeholder="$str.getKey('数据分析/请输入基准值')"
              :disabled="line.id !== formData.editDlId"></el-input>
          </div>
          <el-button v-if="false" class="sub-btn" @click="deleteDatumLine" :icon="Minus" plain></el-button>
        </div>
      </div>
      <!-- 新增基准线：展示&编辑 -->
      <div v-for="(line, idx) in formData.addList" :key="line.id" v-if="formData.isShowAdd">
        <div class="item-container">
          <div class="name-container">
            <div class="label-container">*{{ $str.getKey('数据分析/基准线名称') }}:</div>
            <el-input class="name-input" v-model="line.name" :placeholder="$str.getKey('数据分析/请输入基准线名称')"></el-input>
          </div>
          <div class="value-container">
            <div class="label-container">*{{ $str.getKey('数据分析/基准值') }}:</div>
            <el-input class="value-input" v-model="line.value" :placeholder="$str.getKey('数据分析/请输入基准值')"></el-input>
          </div>
          <el-button v-if="(idx + 1) == formData.addList.length" class="add-btn" @click="addDatumLine" :icon="Plus"
            plain></el-button>
          <el-button v-else class="sub-btn" @click="deleteDatumLine(idx)" :icon="Minus" plain></el-button>
        </div>
      </div>
    </div>

    <template #footer>
      <el-button @click="handleClose" class="custom-cancel-btn">{{ $str.getKey('数据分析/取消') }}</el-button>
      <el-button type="primary" @click="onConfirm" class="custom-confirm-btn" :disabled="isConfirming">{{
        $str.getKey('数据分析/确定') }}</el-button>
    </template>
  </Dialog>
</template>
<script setup>
import { defineEmits, defineOptions, defineProps, onMounted, reactive, ref, getCurrentInstance, watch, computed } from "vue";
import { useVModel } from "@vueuse/core";
import { cloneDeep } from "@/utils"
import { Plus, Minus, Delete } from '@element-plus/icons-vue'
import { createDatumLinesApi, updateDatumLineApi } from './api/index.js'
import { useAppStore } from "@/store/modules/app";

const $str = window.$str;
const stationId = computed(() => {
  return useAppStore().stationId
})

/** 设置组件配置项 */
defineOptions({
  name: "AddDatumLineModal"
});

/** 接收父组件信息 */
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  operateType: {
    type: String,
    default: ''
  },
  datumLines: {
    type: Array,
    default: []
  },
  dlId: {
    type: String,
    default: ''
  },
});

const emit = defineEmits(['update:show', 'SendChange', 'updateDatumLine']);
const showProxy = useVModel(props, "show", emit);
const newItem = { name: '', value: '' };
const formData = reactive({
  existedList: props.datumLines.map(it => {
    return {
      id: it.key,
      name: it.label,
      value: it.data,
    }
  }), // 已经存在的【基准线】
  addList: props.operateType === 'add' ? [cloneDeep(newItem)] : [], // 新增的【基准线】
  isShowAdd: props.operateType === 'add', // 新增的【基准线】
  editDlId: props.dlId, // 被编辑的【基准线】的ID
})
const isConfirming = ref(false); // 防抖【连续多次点击提交按钮】

function addDatumLine() {
  // 基准线数量校验
  if ((formData.existedList.length + formData.addList.length) < 5) {
    formData.addList.push(cloneDeep(newItem));
  } else {
    window.dispatchNotify({
      type: 'info',
      message: '基准线总数量最多为5条'
    })
  }
}
function deleteDatumLine(idx) {
  formData.addList.splice(idx, 1);
}

/** 关闭面板 */
function handleClose() { emit("SendChange", false); }
/** 提交表单 */
function onConfirm() {
  // 校验
  if (!checkDatumLinesData()) {
    return false;
  }

  // 入库
  if (props.operateType == 'add') {
    isConfirming.value = true;
    addDatumLines();
  }
  if (props.operateType == 'edit') {
    isConfirming.value = true;
    updateDatumLine();
  }
}

/** ======【功能方法】============================================================================= */
/** 更新选项列表&图表 */
function updateDeviceList(msg) { emit("updateDatumLine", msg); }

/** 添加基准线 */
function addDatumLines() {
  const params = {
    stationId: stationId.value,
    baselineList: formData.addList.map(line => {
      return {
        name: line.name,
        value: Number(line.value)
      }
    }),
    type: 2
  }
  createDatumLinesApi(params).then(res => {
    if (res?.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: '添加成功'
      })
      updateDeviceList('add');
    }
  }).catch(err => {
    console.error('基准线添加失败：', err)
    window.dispatchNotify({
      type: 'error',
      message: '添加失败'
    })
  }).finally(() => {
    isConfirming.value = false;
    handleClose();
  })
}

/** 更新基准线 */
function updateDatumLine() {
  const editItem = formData.existedList.find(dl => dl.id === formData.editDlId);
  const params = {
    stationId: stationId.value,
    id: formData.editDlId,
    type: 2,
    baseline: {
      name: editItem.name,
      value: Number(editItem.value)
    },
  }
  updateDatumLineApi(params).then(res => {
    if (res?.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: '更新成功'
      })
      updateDeviceList('update');
    }
  }).catch(err => {
    console.error('基准线更新失败：', err)
    window.dispatchNotify({
      type: 'error',
      message: '更新失败'
    })
  }).finally(() => {
    isConfirming.value = false;
    handleClose();
  })
}

/** 计算字符串占用的字节数 */
function computeStrLenghtWithByte(str) {
  let len = 0;
  const arr = str.split("");
  arr.forEach(ch => {
    if (ch.charCodeAt(0) < 299) {
      len++;
    } else {
      len += 2;
    }
  });
  return len;
}


/** 检查名称长度 */
function checkDlNameLength(list) {
  // 非空校验
  const hasNull = list.some(dl => {
    return String(dl.name).length < 1;
  })
  if (hasNull) {
    window.dispatchNotify({
      type: 'info',
      message: '基准线名称不能为空'
    })
    return false;
  }

  // 长度校验
  const isOverflow = list.some(dl => {
    const len = computeStrLenghtWithByte(dl.name);
    return len > 20;
  })
  if (isOverflow) {
    window.dispatchNotify({
      type: 'info',
      message: '基准线名称已超出长度限制'
    })
    return false;
  }

  // 校验通过
  return true;
}

/** 检查基准值 */
function checkDlValue(list) {
  const hasNull = list.some(dl => {
    return String(dl.value).length < 1;
  })
  if (hasNull) {
    window.dispatchNotify({
      type: 'info',
      message: '基准值不能为空'
    })
    return false;
  }
  const hasNaN = list.some(dl => {
    return isNaN(dl.value);
  })
  if (hasNaN) {
    window.dispatchNotify({
      type: 'info',
      message: '请输入数字格式的基准值'
    })
    return false;
  }
  const isOverflow = list.some(dl => {
    return dl.value > 30000 || dl.value < -3000;
  })
  if (isOverflow) {
    window.dispatchNotify({
      type: 'info',
      message: '基准值不能大于30000且不能小于-30000'
    })
    return false;
  }
  return true;
}

/** 检查名称是否重复 */
function checkNameRepeat() {
  const nameList = [...formData.existedList, ...formData.addList].map(line => line.name);
  const noRepeat = [...new Set(nameList)].length === nameList.length;
  if (!noRepeat) {
    window.dispatchNotify({
      type: 'info',
      message: '基准线名称不能重名'
    })
  }
  return noRepeat;
}

/** 检查数据规范 */
function checkDatumLinesData() {
  // 基准线数量校验
  if ((formData.existedList.length + formData.addList.length) > 5) {
    window.dispatchNotify({
      type: 'info',
      message: '基准线总数量最多为5条'
    })
    return false;
  }
  // 基准线名称长度&基准值校验
  if (props.operateType == 'add') {
    if (!checkDlValue(formData.addList)) {
      return false;
    }
    if (!checkDlNameLength(formData.addList)) {
      return false;
    }
  }
  if (props.operateType == 'edit') {
    const list = formData.existedList.filter(dl => dl.id === formData.editDlId)
    if (!checkDlValue(list)) {
      return false;
    }
    if (!checkDlNameLength(list)) {
      return false;
    }
  }
  // 基准线名称重复校验
  if (!checkNameRepeat()) {
    return false;
  }

  // 校验通过
  return true;
}

</script>




<style lang="scss" scoped>
.view-topo-modal {
  .header-container {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .icon-container {
      width: 29px;
      height: 29px;
      background-image: radial-gradient(#FFF 5%, #3a68ff 30%);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #3a68ff;
      transform: rotate(45deg);
      margin-right: 20px;
    }

    .title-text {
      font-family: PingFang-SC, PingFang-SC;
      font-size: 18px;
      font-weight: 600;
      color: #2e2e2e;
      text-align: left;
      letter-spacing: 1px;
    }
  }

  .modal-container {
    min-height: 200px;
    max-height: 400px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;

    .item-container {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 16px;

      .name-container,
      .value-container {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;

        .label-container {
          min-width: 120px;
          font-size: 14px;
          font-weight: 500;
          color: #2e2e2e;
          display: flex;
          align-items: center;
          white-space: nowrap;
        }

        .name-input,
        .value-input {
          flex: 1;
          max-width: 200px;
        }
      }

      .add-btn {
        background: #536BFA;
        border-radius: 6px;
        color: #FFFFFF;
        font-size: 16px;
        border-width: 0;
        width: 40px;
        height: 40px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 16px;

        &:hover {
          background: #4A5FE8;
          box-shadow: 0 2px 8px rgba(83, 107, 250, 0.3);
        }
      }

      .sub-btn {
        background: #F56C6C;
        border-radius: 6px;
        color: #FFFFFF;
        font-size: 16px;
        border-width: 0;
        width: 40px;
        height: 40px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 16px;

        &:hover {
          background: #E45656;
          box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
        }
      }
    }
  }

  .custom-confirm-btn {
    font-family: "HarmonyOS Sans SC", sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    background: #3a68ff !important;
    color: #fff !important;

    &:hover {
      background: #3a68ff !important;
      opacity: 0.9;
    }

    &:active {
      background: #3a68ff !important;
      opacity: 0.8;
    }
  }

  .custom-cancel-btn {
    border: 1px solid rgba(192, 207, 218, 0.3) !important;

    &:hover {
      background: #f5f7fa !important;
      color: #2e2e2e !important;
    }

    &:active {
      background: #f5f7fa !important;
    }
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .modal-container {
      padding: 16px;

      .item-container {
        flex-direction: column;
        gap: 16px;

        .name-container,
        .value-container {
          width: 100%;

          .name-input,
          .value-input {
            max-width: none;
          }
        }

        .add-btn,
        .sub-btn {
          align-self: flex-end;
          margin-left: 0;
        }
      }
    }
  }
}
</style>
